import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=21ab7acc&"
import script from "./qr-code.vue?vue&type=script&lang=js&"
export * from "./qr-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ab7acc')) {
      api.createRecord('21ab7acc', component.options)
    } else {
      api.reload('21ab7acc', component.options)
    }
    module.hot.accept("./qr-code.vue?vue&type=template&id=21ab7acc&", function () {
      api.rerender('21ab7acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/qr-code.vue"
export default component.exports